import { configureStore } from '@reduxjs/toolkit';
import {authReducer,usersReducer} from '../features/UserSlice';
import { 
    workspaceReducer,
    siteReducer,
    buildingReducer,
    addUserReducer,
    deleteUserReducer,
    updateUserReducer,
    usersPermissionsReducer,
    activitiesReducer,
    deleteWorkspaceReducer,
    projectsReducer,
    deleteSiteReducer,
    addSiteReducer,
    updateSiteReducer,
    componentsReducer,
    incidentsReducer,

} from '../features/SuperAdminSlice';

import themeReducer from '../features/themeSlice';

import {pricingReducer,settingsReducer,pricingHomeReducer} from './PricingSettingsSlice';
import { actionsReducer } from './ActionsTrackingSlice';
import { correctionsReducer } from './CorrectionsSlice';
import { reservationsReducer } from './ReservationsSlice';
import { serviceProvidersReducer } from './ServiceProvidersSlice';
import { documentsReducer } from './Documents';
import { investmentsReducer, investmentsReportsReducer } from './Investments';
import { occupantsRequestsReducer } from './OccupantsRequests';
import { constructionProjectsReducer } from './ContructionProjects';
import { correctiveActionsReducer } from './CorrectiveActionsSlice';
import { deviationsReducer } from './DeviationsSlice';
import { maintenanceTasksReducer } from './MaintenanceTasks';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        users:usersReducer,
        workspaces:workspaceReducer,
        sites:siteReducer,
        buildings:buildingReducer,
        addUser:addUserReducer,
        deleteUser:deleteUserReducer,
        deleteSiteRe:deleteSiteReducer,
        updateUser: updateUserReducer,
        usersPermissions:usersPermissionsReducer,
        activities:activitiesReducer,
        deleteWorkspace:deleteWorkspaceReducer,
        projects:projectsReducer,
        addSiteRe:addSiteReducer,
        updateSiteRe:updateSiteReducer,
        components:componentsReducer,
        incidents:incidentsReducer,
        theme: themeReducer,
        pricing:pricingReducer,
        settings:settingsReducer,
        pricingHome:pricingHomeReducer,
        actions:actionsReducer,
        corrections:correctionsReducer,
        reservations:reservationsReducer,
        serviceProviders:serviceProvidersReducer,
        allDocuments:documentsReducer,
        investments:investmentsReducer,
        reports:investmentsReportsReducer,
        occupantsRequests:occupantsRequestsReducer,
        constructionProjects:constructionProjectsReducer,
        correctiveActions:correctiveActionsReducer,
        deviations:deviationsReducer,
        maintenanceTasks:maintenanceTasksReducer
    },
});